(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    // Charge les 2 photos suivantes de la vignette au moment où la cliente interagit avec le carrousel
    const loadNext = (gallery) => {
      const slides = [...gallery.querySelectorAll('.splide__slide')];
      const active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let loaded = 0;
      for (const slide of slides.slice(active + 1)) {
        const template = slide.querySelector('template[data-deferred-media]');
        if (template) template.replaceWith(template.content.cloneNode(true));
        if (++loaded === 2) break;
      }
    };

    const onInteract = (event) => {
      if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
      const gallery = event.target.closest?.('product-card-media-gallery');
      if (gallery) loadNext(gallery);
    };

    ['pointerover', 'pointerdown', 'touchstart', 'focusin'].forEach((type) => {
      document.addEventListener(type, onInteract, { passive: true, capture: true });
    });
    // Après chaque défilement, prépare les photos suivantes
    document.addEventListener('click', onInteract, { capture: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
